export const state = () => ({
  preloadStatus: {
    Languages: {
      name: 'Languages'
    },
    'User Details': {
      name: 'User Details'
    },
    'Users Delegated By': {
      name: 'Users Delegated By'
    },
    'System Variables': {
      name: 'System Variables'
    }
  },
  apisPreloading: false
});
